import DateStringInput, { DateStringInputProps } from '@repo/ui/date-string-input'

import useTranslate from '../../../lib/hooks/use-translate'
import { useFormField } from '../forms/form'

const ControlledDateStringInput: React.FC<DateStringInputProps> = ({ ...props }) => {
  const { error } = useFormField()
  const { currentLanguage } = useTranslate()
  const value = props.value

  return (
    <DateStringInput
      {...props}
      language={currentLanguage}
      value={value}
      errorMessage={error ? String(error?.message) : undefined}
    />
  )
}

export default ControlledDateStringInput
